var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgVideoCallButton(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Base_Icon"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M3.77881 19.8504C3.35165 19.8504 2.98098 19.6933 2.66681 19.3791C2.35248 19.0648 2.19531 18.6941 2.19531 18.2671V5.73364C2.19531 5.30664 2.35248 4.93597 2.66681 4.62164C2.98098 4.30747 3.35165 4.15039 3.77881 4.15039H16.3156C16.7344 4.15039 17.1024 4.30747 17.4196 4.62164C17.7367 4.93597 17.8953 5.30664 17.8953 5.73364V10.8336L21.1288 7.60039C21.251 7.47822 21.3954 7.44839 21.5621 7.51089C21.7287 7.57339 21.8121 7.69214 21.8121 7.86714V16.1371C21.8121 16.309 21.7287 16.4264 21.5621 16.4894C21.3954 16.5522 21.251 16.5226 21.1288 16.4004L17.8953 13.1671V18.2671C17.8953 18.6941 17.7367 19.0648 17.4196 19.3791C17.1024 19.6933 16.7344 19.8504 16.3156 19.8504H3.77881ZM3.77881 18.2671H16.3121V5.73364H3.77881V18.2671Z",
    fill: "#141414"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgVideoCallButton);
export default __webpack_public_path__ + "static/media/video_call_button.ad8739d880b299a43512a73edff716c3.svg";
export { ForwardRef as ReactComponent };